//import axios from "axios";
import Rest from "@/api/Rest";
import Lytics from "@/classes/Lytics";
import moment from "moment";
import {RaddarEvent} from "@/features/raddar/store/raddar";
import router from "@/router";
import ShoppingListController, {getProductSku} from "@/features/shopping-list/classes/ShoppingListController";


const state = {
	showShoppingList: false,
	showShoppingListV1:false,
	showShoppingListV2:false,
	shoppingListItems:[],
	shoppingList: [],
	shoppingListV1:[],
	shoppingListV2:[],
	emailError: false,
	additionalItemInputFocus: false,
	emailInputFocus: false,
	additionalItemCount: 0,
	flyerDate: null
};

const getters = {
	config(state, getters, rootState, rootGetters) {
		const settings = rootGetters['config/features'];
		return settings?.shoppingList;
	},
	enabled(state, getters) {
		return getters.config?.enabled;
	},
	getVersion(state, getters) {
		return getters.config.component || ''
	},
	dealId(state, getters, rootState, rootGetters) {
		return rootGetters["landingPage/currentFlyer"]?.title;
	},
	// Scopes "My List" persistence to the store rather than the individual flyer, so items
	// added while viewing one flyer stay visible/highlighted when viewing another flyer at
	// the same store.
	listKey(state, getters, rootState, rootGetters) {
		return String(rootGetters.storeId);
	},
	/*shoppingListItems(state, getters) {
		return getters.version === 'v1'? state.shoppingListV1: state.shoppingList;
	},*/
	shoppingListSKUs(state) {
		return state.shoppingListItems.map((item) => {
			return item.product.sku;
		})
	},
	productsBySKU(state) {
		const o = {};
		state.shoppingListItems.forEach((item) => {
			o[getProductSku(item.product)] = item.product;
		})
		return o;
	},
};

const actions = {
	toggleShoppingList({commit}, value) {
		commit('SHOW_SHOPPING_LIST', value);
	},
	toggleShoppingListV1({commit}, value) {
		commit('SHOW_SHOPPING_LISTV1', value);
	},
	toggleShoppingListV2({commit}, value) {
		commit('SHOW_SHOPPING_LISTV2', value);
	},

	skuAddToList({dispatch, rootGetters}, sku) {
		let product = null;

		rootGetters.filterableItems.some(item => {
			product = item.products.find(product => product.sku == sku);
			return product;
		});

		if (!product) return;

		const additionalItemFlag = false;
		const prod = state.shoppingList.filter(product => product.sku === sku);
		if (prod.length == 0) {
			dispatch('setAddToList', {product, additionalItemFlag});
			return true
		} else
			return false;
	},
	addProductToList({ commit, getters, dispatch, rootState, rootGetters }, product) {
		const isPersonalizedOffer = (rootGetters['ctUser/triangleOffers'] || []).some(offer => offer.sku === product.sku);
		
		Lytics.TriggerAddToWishlist({
			page_number: rootState.currentPageNumber,
			name: product.productEn || product.productFr,
			name_en: product.productEn,
			name_fr: product.productFr,
			product_id: product.sku,
			price: product.regularPrice,
			sale_price: product.salePrice,
			category: product.mainCategoryEn || product.mainCategoryFr,
			category_2: product.subCategoryEn || product.subCategoryFr,
			image_url: product.productImage,
			quantity: product.quantity,
			personalized_offer: isPersonalizedOffer,
		});
		const list = new ShoppingListController(getters.listKey);
		const itemAdded = list.addItem(product.sku, product);
		console.log("ShoppingList Controller AddItem:", itemAdded);
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
		dispatch('events/triggerEvent', {event: RaddarEvent.ShoppingList.Add, data: product}, {root: true});
	},
	removeProductFromList({commit, getters, dispatch}, product){
		console.log('Remove from List:', product);
		const list = new ShoppingListController(getters.listKey);
		const removedItem = list.removeItem(product?.sku);
		console.log("ShoppingList Controller RemoveItem:", removedItem);
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
		dispatch('events/triggerEvent', {event: RaddarEvent.ShoppingList.Remove, data: product}, {root: true})
	},

	setAddToList({commit, dispatch, rootState, rootGetters, getters}, payload) {
		if (state.shoppingListV1.length === 0) {
			Lytics.TriggerShoppingListStart();
		}
		const list = new ShoppingListController(getters.listKey);
		console.log("ShoppingList Controller AddItem:", list.addItem(payload.sku || payload?.product?.sku, payload?.product || payload));

		commit('ADD_ITEM_SHOPPING_LIST', {payload, rootState, rootGetters});

		dispatch('events/triggerEvent', {event: RaddarEvent.ShoppingList.Add, data: payload}, {root: true});
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
	},
	setRemoveFromList({commit, dispatch, rootState, rootGetters, getters}, payload) {
		//Lytics.TriggerShoppingListProduct('remove', payload.product);
		console.log('Remove from List:', payload);
		const list = new ShoppingListController(getters.listKey);
		console.log("ShoppingList Controller RemoveItem:", list.removeItem(payload?.sku || payload?.product?.sku));

		commit('REMOVE_ITEM_SHOPPING_LIST', {payload, rootState, rootGetters})
		dispatch('events/triggerEvent', {event: RaddarEvent.ShoppingList.Remove, data: payload}, {root: true})
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
		//return true;
	},
	quantityChange({commit, dispatch, rootState, rootGetters, getters}, payload) {
		//Lytics.TriggerShoppingListProduct('change_count', payload)
		commit('HANDLE_QTY_CHANGE', {payload, rootState, rootGetters, dispatch})
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
	},
	clearAll({commit, dispatch, rootState, rootGetters, getters}) {
		const list = new ShoppingListController(getters.listKey);
		list.clear()

		Lytics.TriggerShoppingList("clear");
		commit('CLEAR_SHOPPING_LIST', {rootState, rootGetters})
		dispatch('events/triggerEvent', {event: RaddarEvent.ShoppingList.Clear, data: {}}, {root: true})
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
	}, // eslint-disable-next-line no-unused-vars
	async sendEmail({dispatch, rootState}, payload) {
		try {
			await Rest.Post('products/email', payload);
			Lytics.TriggerShoppingList("email");
			/*await axios.post(`${rootState.apiUrl}/products/email`,
                    payload,
              {
               headers: {
                   'Ocp-Apim-Subscription-Key':`${rootState.subscriptionKey}`,
                   'content-type':'application/json;charset=UTF-8',
               }
           })*/
		} catch (error) {
			if (error.response.status != 200) dispatch('setEmailError', true)
			console.log(error);
		}
	},
	setShoppingList({commit, getters}, payload) {
		commit('SET_SHOPPING_LIST', payload)
		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
	},
	setEmailError({commit}, val) {
		commit('EMAIL_ERROR', val)
	},
	setAdditionalItemInputFocus({commit}, val) {
		commit('SET_ADDITIONAL_ITEM_FOCUS', val)
	},
	setEmailInputFocus({commit}, val) {
		commit('SET_EMAIL_INPUT_FOCUS', val)
	},
	handleLocalStorage({rootGetters, dispatch, commit, getters}) {

		commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);

		// Scoped by storeId now (not by flyer), so the list is shared across every flyer
		// at this store and is no longer expired based on any single flyer's end date -
		// it persists until the user clears it (or switches to a different store).
		let data;
		try {
			data = JSON.parse(localStorage[`data_store_${rootGetters.storeId}`])
		} catch (e) {
			dispatch('setShoppingList', [])
			return true;
		}

		const version = getters.getVersion;
		if (version === 'v2') {
			commit('SET_SHOPPING_LIST_V2', data.shoppingList);
			commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
		} else if (version === 'v1') {
			commit('SET_SHOPPING_LIST_V1', data.shoppingList);
			commit('UPDATE_SHOPPING_LIST_ITEMS', getters.listKey);
		} else {
			dispatch('setShoppingList', data.shoppingList);
		}
	},
	handleFlyerDate({commit}, value) {
		commit("SET_FLYER_DATE", value)
	}
};

const mutations = {

	UPDATE_SHOPPING_LIST_ITEMS(state, listId) {
		/*console.log('Shoppinglist Update Items:', listId)*/
		const list = new ShoppingListController(listId);
		state.shoppingListItems = list.getList();
	},

	SET_SHOPPING_LIST(state, value) {
		state.shoppingList = value
	},
	SET_SHOPPING_LIST_V1(state, value) {
		state.shoppingListV1 = value
	},
	SET_SHOPPING_LIST_V2(state, value) {
		state.shoppingListV2 = value
	},
	SHOW_SHOPPING_LIST(state, value) {
		state.showShoppingList = value;
	},
	SHOW_SHOPPING_LISTV1(state, value) {
		state.showShoppingListV1 = value;
	},
	SHOW_SHOPPING_LISTV2(state, value) {
		state.showShoppingListV2 = value;
	},
	SET_FLYER_DATE(state, val) {
		state.flyerDate = val;
	},

	ADD_ITEM_SHOPPING_LIST(state, {payload, rootGetters, rootState}) {
		const currentFlyer = rootGetters["landingPage/currentFlyer"]
		let newElement, sp, savings='', price='', pq='';
		if(payload.version==="v1") {
			const date = router.currentRoute.query['timeTravelDate'] ?? moment();
			//subtracting and adding 1 day because isBetween function from momentJS doesn't consider the actual date (same day)
			const startDate = moment(payload.product?.validFrom).subtract(1, "days")
			const endDate = moment(payload.product?.validTo).add(1, "days")
			let isTodayBetweenValidity = moment(date).isBetween(startDate, endDate);
			if (payload.product?.tags?.includes('S&S')) {
				price = payload.product?.salePrice
			} else {
				if (payload.product?.savingsEn)
					price = payload.product.savingsPrefix + ' ' + payload.product.savingsEn
				else price = isTodayBetweenValidity === true ? payload.product?.salePrice : payload.product?.rowPrice || '';
			}
			if (price !== '' && price !== null && !payload.product?.savingsEn)
            {
                sp = payload.product?.priceSign?.includes('$') ? `${payload.product.priceSign}${(price)} ` : `${price}${payload.product?.priceSign}`;
            }

			else sp = price
			if (sp === '' || sp === null) {
				sp = payload.product?.savingsEn ? payload.product.savingsPrefix + ' ' + payload.product.savingsEn : ''
			}
			if (payload.additionalItemFlag === false) {
				newElement = {
					productEn: payload.product.productEn,
					productFr: payload.product.productFr,
					productImage: payload.product.productImage, //salePrice: rootGetters.language=='en' ? '$'+parseFloat(payload.product.salePrice).toFixed(2) : parseFloat(payload.product.salePrice).toFixed(2).replace(".",",")+'$',
					//salePrice: (rootGetters.language == 'en' && (payload.product.salePriceFr === 'NaN' || payload.product.salePriceFr === '' || payload.product.salePriceFr == null)) ? '' : (rootGetters.language == 'en' && (isNaN(payload.product.salePriceFr))) ? (payload.product.salePriceFr) : (rootGetters.language == 'en' && (payload.product.salePriceFr.includes('à'))) ? '$' + (payload.product.salePriceFr) : (rootGetters.language == 'en' && (payload.product.salePriceFr !== 'NaN' || payload.product.salePriceFr !== '' || payload.product.salePriceFr !== null || !payload.product.salePriceFr.includes('à'))) ? '$' + (parseFloat(payload.product.salePriceFr).toFixed(2))

					//	: (rootGetters.language !== 'en' && (payload.product.salePriceFr === 'NaN' || payload.product.salePriceFr === '' || payload.product.salePriceFr == null)) ? '' : (rootGetters.language !== 'en' && (isNaN(payload.product.salePrice))) ? (payload.product.salePriceFr) : (rootGetters.language !== 'en' && (payload.product.salePriceFr.includes('à'))) ? (payload.product.salePriceFr.replaceAll(".", ",")) + '$' : (rootGetters.language !== 'en' && (payload.product.salePriceFr !== 'NaN' || payload.product.salePriceFr !== '' || payload.product.salePriceFr !== null || !payload.product.salePriceFr.includes('à'))) ? (parseFloat(payload.product.salePriceFr).toFixed(2)).replace(".", ",") + '$' : '$' + payload.product.salePriceFr,
					salePrice: payload.product.tags?.includes("bogo") ? payload.product.savingsEn : sp,
					limitQty: isTodayBetweenValidity === true && !payload.product?.tags?.includes('S&S') ? payload.product.limitQty : '',
					regularPrice: payload.product.regularPrice,
					item: '',
					contents: payload.product.contents,
					sku: payload.product.sku,
					quantity: 1,
					validFrom: payload.product.validFrom,
					validTo: payload.product.validTo,
					flyerDate: state.flyerDate,
					priceQuantity: isTodayBetweenValidity === true ? payload.product.priceQuantity : '',
					salePricePrefix: (rootGetters.language === 'en') ? payload.product.salePricePrefixEn : payload.product.salePricePrefixFr
				}
			} else {
				state.additionalItemCount += 1
				newElement = {
					productEn: '',
					productFr: payload.additionalItem,
					productImage: '/images/icon-generic-product.svg',
					salePrice: payload.additionalItem,
					limitQty: null,
					regularPrice: '',
					item: payload.additionalItem,
					sku: state.additionalItemCount.toString(),
					contents: '',
					quantity: 1,
					validFrom: '',
					validTo: '',
					flyerDate: '',
					priceQuantity: '',
					salePricePrefix: ''
				}
			}
			state.shoppingListV1.push(newElement);
			localStorage[`data_store_${rootGetters.storeId}`] = JSON.stringify({
				shoppingList: state.shoppingListV1, lang: rootGetters.language, content: rootGetters.content, startDate: currentFlyer.startDate, endDate: currentFlyer.endDate, currentDeal: currentFlyer.title
			});
		}
		else if(payload.version==="v2"){
			if(payload.isXdaySale){
				if(payload.product?.rowPrice)
					price= price + payload.product?.rowPrice
				if(payload.product?.rowPriceQty)
					pq = payload.product?.rowPriceQty
			}

			else if (payload.product?.memberPriceEn || payload.product?.memberPriceFr || payload.product?.memberSave) {
				rootGetters.language=='en' && (payload.product?.memberPricePrefixEn ) ? price= payload.product?.memberPricePrefixEn?.replace(/\w\S*/g, (txt) => {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()})+' ' : ''
				rootGetters.language=='fr' && (payload.product?.memberPricePrefixFr ) ? price= payload.product?.memberPricePrefixFr?.replace(/\w\S*/g, (txt) => {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()})+' ' : ''

				if(payload.product?.memberPriceQuantity) price = price+payload.product?.memberPriceQuantity+' / '
				rootGetters.language=='en' ? price= price+' '+ parseFloat(payload.product?.memberPriceEn).toFixed(2) : price= price+' '+ parseFloat(payload.product?.memberPriceFr).toFixed(2)

				if(payload.product?.memberPriceUnit) price= price+' '+payload.product?.memberPriceUnit
				if(payload.product?.memberSavePrefix) price= price+' '+payload.product?.memberSavePrefix?.replace(/\w\S*/g, (txt) => {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()});
				if(payload.product?.memberSave) price= price+' '+payload.product?.memberSave
				if(payload.product?.memberSaveSuffixEn) price= price+' '+payload.product?.memberSaveSuffixEn?.replace(/\w\S*/g, (txt) => {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()})

				if(payload.product.salePricePrefixEn && rootGetters.language=="en"){
					savings=payload.product?.salePricePrefixEn+' '
					if(payload.product?.priceQuantity)
						savings += payload.product?.priceQuantity+' / '
					if(payload.product?.salePrice)
						savings += parseFloat(payload.product?.salePrice).toFixed(2)
				}

				else if(payload.product.salePricePrefixFr && rootGetters.language=="fr"){
					savings=payload.product?.salePricePrefixFr+' '
					if(payload.product?.priceQuantity)
						savings += payload.product?.priceQuantity+' / '
					if(payload.product?.salePrice)
						savings += parseFloat(payload.product?.salePrice).toFixed(2)
				}

				if(payload.product.memberSave && payload.product.savingsEn)
					savings = payload.product?.savingsPrefix + ' ' + payload.product?.savingsEn + ' '+payload.product?.savingsSuffix
			}
			else {
				if(rootGetters.language=='en' && payload.product?.salePricePrefixEn) price = price+payload.product?.salePricePrefixEn
				if(rootGetters.language=='fr' && payload.product?.salePricePrefixFr)  price = price+payload.product?.salePricePrefixFr
				if(payload.product?.priceQuantity) pq = payload.product?.priceQuantity
				if(payload.product?.salePrice) price= price+' '+ payload.product?.salePrice+' '
				rootGetters.language=='en' ? price= price+payload.product?.promoUnitEn : price= price+payload.product?.promoUnitFr
			}

			if (price === '' || price === null || price=== 'null') {
				price = payload.product?.savingsEn ? payload.product?.savingsPrefix + ' ' + payload.product?.savingsEn + ' '+payload.product?.savingsSuffix : ''
			}
			let c = payload.product?.bodyEn !== payload.product?.bodyFr ? payload.product?.bodyFr +'\n'+payload.product?.bodyEn : rootGetters.language=='en' ? payload.product?.bodyEn : payload.product?.bodyFr

			if (payload.additionalItemFlag === false) {
				newElement = {
					productEn: payload.product.productEn,
					productFr: payload.product.productFr,
					productImage: payload.product.productImage,
					salePrice: price.replaceAll("null",''),
					limitQty: payload.product?.limitQty || '',
					regularPrice: payload.product.regularPrice ||'',
					item: '',
					contents: c.replaceAll('null',''),
					sku: payload.product.sku,
					quantity: 1,
					// pharma: payload.isPharma,
					validFrom: payload.isXdaySale ? payload.product.validFromROW : payload.product.validFrom,
					validTo: payload.isXdaySale ? payload.product.validToROW : payload.product.validTo,
					flyerDate: state.flyerDate,
					priceQuantity: pq.replaceAll("null",''),
					salePricePrefix:  savings.replaceAll("null",'')
				}
			} else {
				state.additionalItemCount += 1
				newElement = {
					productEn: payload.additionalItem,
					productFr: payload.additionalItem,
					productImage: '/images/icon-generic-product.svg',
					salePrice: '',
					limitQty: null,
					regularPrice: '',
					item: payload.additionalItem,
					sku: state.additionalItemCount.toString(),
					contents: '',
					quantity: 1,
					validFrom: '',
					validTo: '',
					flyerDate: '',
					priceQuantity: '',
					salePricePrefix: ''
				}
			}
			state.shoppingListV2.push(newElement);
			localStorage[`data_store_${rootGetters.storeId}`] = JSON.stringify({
				shoppingList: state.shoppingListV2, lang: rootGetters.language, content: rootGetters.content, startDate: currentFlyer.startDate, endDate: currentFlyer.endDate, currentDeal: currentFlyer.title
			});
		}
		else {
			if (payload.additionalItemFlag == false) {
				newElement = {
					productEn: payload.product.productEn,
					productFr: payload.product.productFr,
					productImage: payload.product.productImage, //salePrice: rootGetters.language=='en' ? '$'+parseFloat(payload.product.salePrice).toFixed(2) : parseFloat(payload.product.salePrice).toFixed(2).replace(".",",")+'$',
					salePrice: (rootGetters.language == 'en' && (payload.product.salePriceFr === 'NaN' || payload.product.salePriceFr === '' || payload.product.salePriceFr == null)) ? '' : (rootGetters.language == 'en' && (isNaN(payload.product.salePriceFr))) ? (payload.product.salePriceFr) : (rootGetters.language == 'en' && (payload.product.salePriceFr.includes('à'))) ? '$' + (payload.product.salePriceFr) : (rootGetters.language == 'en' && (payload.product.salePriceFr !== 'NaN' || payload.product.salePriceFr !== '' || payload.product.salePriceFr !== null || !payload.product.salePriceFr.includes('à'))) ? '$' + (parseFloat(payload.product.salePriceFr).toFixed(2))

						: (rootGetters.language !== 'en' && (payload.product.salePriceFr === 'NaN' || payload.product.salePriceFr === '' || payload.product.salePriceFr == null)) ? '' : (rootGetters.language !== 'en' && (isNaN(payload.product.salePrice))) ? (payload.product.salePriceFr) : (rootGetters.language !== 'en' && (payload.product.salePriceFr.includes('à'))) ? (payload.product.salePriceFr.replaceAll(".", ",")) + '$' : (rootGetters.language !== 'en' && (payload.product.salePriceFr !== 'NaN' || payload.product.salePriceFr !== '' || payload.product.salePriceFr !== null || !payload.product.salePriceFr.includes('à'))) ? (parseFloat(payload.product.salePriceFr).toFixed(2)).replace(".", ",") + '$' : '$' + payload.product.salePriceFr,
					regularPrice: payload.product.regularPrice,
					item: '',
					sku: payload.product.sku,
					quantity: 1,
					validFrom: payload.product.validFrom,
					validTo: payload.product.validTo,
					priceQuantity: payload.product.priceQuantity,
					salePricePrefix: (rootGetters.language == 'en') ? payload.product.salePricePrefixEn : payload.product.salePricePrefixFr
				}
			}
			else {
				state.additionalItemCount += 1
				newElement = {
					productEn: '',
					productFr: payload.additionalItem,
					productImage: '/images/icon-generic-product.svg',
					salePrice: '',
					regularPrice: '',
					item: payload.additionalItem,
					sku: state.additionalItemCount.toString(),
					quantity: 1,
					validFrom: '',
					validTo: '',
					priceQuantity: '',
					salePricePrefix: ''
				}
				console.log(newElement)

			}
			state.shoppingList.push(newElement);
			localStorage[`data_store_${rootGetters.storeId}`] = JSON.stringify({
				shoppingList: state.shoppingList, lang: rootGetters.language, content: rootGetters.content, startDate: currentFlyer.startDate, endDate: currentFlyer.endDate, currentDeal: currentFlyer.title
			});
		}
		Lytics.TriggerShoppingListProduct("add", newElement.productEn || newElement.productFr, newElement);

    const isPersonalizedOffer = (rootGetters['ctUser/triangleOffers'] || []).some(offer => offer.sku === newElement.sku);
		
		Lytics.TriggerAddToCart({
			page_number: rootState.currentPageNumber,
			name: newElement.productEn || newElement.productFr,
			name_en: newElement.productEn,
			name_fr: newElement.productFr,
			product_id: newElement.sku,
			price: newElement.regularPrice,
			sale_price: newElement.salePrice,
			category: newElement.mainCategory,
			category_2: newElement.subCategory,
			image_url: newElement.productImage,
			quantity: newElement.quantity,
			personalized_offer: isPersonalizedOffer,
		});
	},

	REMOVE_ITEM_SHOPPING_LIST(state, {payload, rootGetters}) {
		const version = payload?.version
		const product =  version==='v1' ? state.shoppingListV1.filter(p=>p.sku===payload.product.sku) : state.shoppingList.filter(p=>p.sku===payload.sku)
		if(version==='v1') state.shoppingListV1 = state.shoppingListV1.filter(product => product.sku !== payload.product.sku);
		else if(version==='v2') state.shoppingListV2 = state.shoppingListV2.filter(product => product.sku !== payload.product.sku);
		else state.shoppingList = state.shoppingList.filter(product => product.sku !== payload.sku);

		Lytics.TriggerShoppingListProduct("remove", product.productEn || product.productFr, product);
		const currentFlyer = rootGetters["landingPage/currentFlyer"]
		localStorage[`data_store_${rootGetters.storeId}`] = JSON.stringify({
			shoppingList: version=='v1' ? state.shoppingListV1 : version=='v2' ? state.shoppingListV2 : state.shoppingList, lang: rootGetters.language, content: rootGetters.content, startDate: currentFlyer.startDate, endDate: currentFlyer.endDate, currentDeal: currentFlyer.title
		});
	},

	HANDLE_QTY_CHANGE(state, {payload, rootGetters, dispatch}) {
		let item;
		const version = payload?.version;

		if(version==='v1') item = state.shoppingListV1.filter(product => product.sku === payload.sku);
		else if(version==='v2') item = state.shoppingListV2.filter(product => product.sku === payload.sku);
		else item = state.shoppingList.filter(product => product.sku === payload.sku);

		Lytics.TriggerShoppingListProduct("change_count", payload.productEn || payload.productFr, payload);
		if (payload.operation == 'plus') item[0].quantity = item[0].quantity + 1;


		else if (payload.operation == 'minus') item[0].quantity = item[0].quantity - 1;

		const currentFlyer = rootGetters["landingPage/currentFlyer"]
		localStorage[`data_store_${rootGetters.storeId}`] = JSON.stringify({
			shoppingList: version=='v1' ? state.shoppingListV1 : version=='v2' ? state.shoppingListV2 : state.shoppingList, lang: rootGetters.language, content: rootGetters.content, startDate: currentFlyer.startDate, endDate: currentFlyer.endDate, currentDeal: currentFlyer.title
		});
		dispatch('events/triggerEvent', {event: RaddarEvent.ShoppingList.Quantity, data: {product: payload, quantity: item[0]?.quantity}}, {root: true})

	}, CLEAR_SHOPPING_LIST(state, {rootGetters}) {
		state.shoppingList = []
		state.shoppingListV1 = []
		state.shoppingListV2 = []
		const currentFlyer = rootGetters["landingPage/currentFlyer"]
		localStorage[`data_store_${rootGetters.storeId}`] = JSON.stringify({
			shoppingList: state.shoppingList, lang: rootGetters.language, content: rootGetters.content, startDate: currentFlyer.startDate, endDate: currentFlyer.endDate, currentDeal: currentFlyer.title
		});
	},

	EMAIL_ERROR(state, val) {
		state.emailError = val;
	}, SET_ADDITIONAL_ITEM_FOCUS(state, val) {
		state.additionalItemInputFocus = val
	}, SET_EMAIL_INPUT_FOCUS(state, val) {
		state.emailInputFocus = val
	},

};

export default {
	namespaced: true, state, getters, actions, mutations,
};